module.exports = __webpack_public_path__ + "static/img/17_phase_function_Paper_Points.f9b7eb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17_phase_function_Paper_Points.png
// module id = XpwB
// module chunks = 0